import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const hostelSections = [
    { id: "intro", name: "छात्रावास परिचय" },
    { id: "policy", name: "प्रवेश नीति" },
    { id: "responsibilities", name: "छात्र जिम्मेदारियाँ" },
    { id: "discipline", name: "अनुशासन" },
    { id: "committee", name: "छात्रावास समिति" },
    { id: "schedule", name: "समय सारणी" },
    { id: "fees", name: "शुल्क संरचना" },
    { id: "contact", name: "सम्पर्क विवरण" }
];

const hostelContent = {
    intro: (
        <section>
            <p>हरियाणा की तपोभूमि कैथल क्षेत्र में हरियाणा सरकार द्वारा स्थापित महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल का अस्थाई परिसर शहर के कुरुक्षेत्र मार्ग पर स्थित है। यहाँ वेद, व्याकरण, ज्योतिष, दर्शन, हिन्दू-अध्ययन एवं योग का अध्ययन-अध्यापन होता है। छात्रों के लिए महिला एवं पुरुष निःशुल्क छात्रावास उपलब्ध है।</p>
        </section>
    ),
    policy: (
        <section>
            <ul>
                <li>दूर इलाकों से आए शैक्षणिक रूप से सुदृढ़ छात्र/छात्राओं को वरीयता।</li>
                <li>कैथल क्षेत्र के छात्रों को प्रवेश नहीं।</li>
                <li>प्रवेश समिति/प्रबंधन के मानदंडों के अनुसार चयन।</li>
                <li>अंशकालिक पाठ्यक्रम वालों को विशेष स्थिति में अनुमति।</li>
            </ul>
        </section>
    ),
    responsibilities: (
        <section>
            <ul>
                <li>कमरे व परिसर की स्वच्छता बनाए रखना।</li>
                <li>अनुशासन, वार्डन के निर्देशों का पालन।</li>
                <li>शैक्षणिक संगोष्ठियों में भाग लेना अनिवार्य।</li>
                <li>बौद्धिक व शारीरिक गतिविधियों में सहभागिता।</li>
                <li>वार्डन से पूर्व अनुमति लेना आवश्यक।</li>
            </ul>
        </section>
    ),
    discipline: (
        <section>
            <ul>
                <li>दैनिक उपस्थिति अनिवार्य।</li>
                <li>अनुपस्थिति पर स्पष्टीकरण और दंड शुल्क।</li>
                <li>देर शाम तक परिसर लौटने की समय सीमा निर्धारित।</li>
                <li>रेंगिंग, धूम्रपान, मादक द्रव्यों पर प्रतिबंध।</li>
                <li>बिजली उपकरण रखने पर जुर्माना।</li>
                <li>पहचान पत्र साथ रखना अनिवार्य।</li>
            </ul>
        </section>
    ),
    committee: (
        <section>
            <ol>
                <li>शैक्षणिक अधिष्ठाता - (चैयरमैन)</li>
                <li>डॉ. रामानन्द मिश्रा - चीफ वार्डन</li>
                <li>डॉ. शर्मिला – वार्डन, महिला छात्रावास</li>
                <li>डॉ. देवेन्द्र सिंह – वार्डन, पुरुष छात्रावास</li>
                <li>श्री रमेश, क्लर्क (HKRN)</li>
            </ol>
            <p>पंजीकृत छात्र:</p>
            <ul>
                <li>पुरुष छात्रावास – 40</li>
                <li>महिला छात्रावास – 20</li>
            </ul>
        </section>
    ),
    schedule: (
        <section>
            <table className="table table-bordered">
                <thead>
                    <tr><th>समय</th><th>क्रिया</th></tr>
                </thead>
                <tbody>
                    <tr><td>05:30</td><td>जागरण</td></tr>
                    <tr><td>06:00 – 07:00</td><td>व्यायाम</td></tr>
                    <tr><td>07:00 – 07:30</td><td>स्नान</td></tr>
                    <tr><td>07:30 – 08:00</td><td>नाश्ता</td></tr>
                    <tr><td>08:00</td><td>विश्वविद्यालय प्रस्थान</td></tr>
                    <tr><td>04:30</td><td>छात्रावास वापसी</td></tr>
                    <tr><td>04:30 – 05:30</td><td>आराम</td></tr>
                    <tr><td>05:30 – 06:30</td><td>क्रीड़ा</td></tr>
                    <tr><td>06:30 – 07:00</td><td>स्नान</td></tr>
                    <tr><td>07:00 – 07:30</td><td>संध्या</td></tr>
                    <tr><td>07:30 – 08:00</td><td>भोजन</td></tr>
                    <tr><td>08:00 – 10:00</td><td>स्वाध्याय</td></tr>
                    <tr><td>10:00</td><td>शयन</td></tr>
                </tbody>
            </table>
        </section>
    ),
    fees: (
        <section>
            <p>कुल शुल्क – ₹650/- (जिसमें ₹500/- सुरक्षित राशि है)</p>
        </section>
    ),
    contact: (
        <section>
            <table className="table table-bordered">
                <thead>
                    <tr><th>पद</th><th>नाम</th><th>संपर्क</th></tr>
                </thead>
                <tbody>
                    <tr><td>चीफ वार्डन</td><td>डॉ. रामानन्द मिश्रा</td><td>73551-15414</td></tr>
                    <tr><td>वार्डन (महिला)</td><td>डॉ. शर्मिला</td><td>92546-40788</td></tr>
                    <tr><td>वार्डन (पुरुष)</td><td>डॉ. देवेन्द्र सिंह</td><td>99118-72115</td></tr>
                    <tr><td>क्लर्क</td><td>श्री रमेश</td><td>93154-17281</td></tr>
                </tbody>
            </table>
        </section>
    )
};

export default function Dormitory() {
    const [activeTab, setActiveTab] = useState("intro");
    const [showSidebar, setShowSidebar] = useState(true);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle button for small screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">छात्रावास</h5>
                <div className="flex-grow-1 overflow-auto">
                    {hostelSections.map((section) => (
                        <p
                            key={section.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeTab === section.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeTab === section.id ? "#77236b" : "",
                            }}
                            onClick={() => {
                                setActiveTab(section.id);
                                setShowSidebar(false);
                            }}
                        >
                            {section.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => setShowSidebar(false)}
            >
                <h4 className="text-center mb-4 fw-bold" style={{ color: '#77236b' }}>
                    {hostelSections.find(s => s.id === activeTab)?.name}
                </h4>
                {hostelContent[activeTab] || <p className="text-muted">कृपया एक अनुभाग चुनें।</p>}
            </main>
        </div>
    );
}
